export function Menu(options = {}) {

  this.isOpen = options.isOpen ? options.isOpen : false;

  return {

    isOpen: this.isOpen,

    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    toggle() {
      this.isOpen ? this.close() : this.open();
    },

    onKeydown(event) {
      if (event.keyCode === 27) this.close(event) // esc
    },

    onUpdate(event) {
      event.detail.isOpen ? this.open() : this.close();
    }

  }

}

window.menu = Menu;
